import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UnifiedSearchResult } from 'src/app/media-app/models/unified-search-result.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UnifiedSearchService {
  private apiEndPoint = environment.apiBaseUrl + 'api/media/search';

  constructor(private http: HttpClient) {}

  search(query: string, limit = 10): Observable<UnifiedSearchResult> {
    let params = new HttpParams().set('q', query);
    params = params.set('limit', limit.toString());

    return this.http.get<UnifiedSearchResult>(this.apiEndPoint, { params });
  }
}
